import api from "../../baseurl";

const Create = async () => {
    const Create = await api.get("blogposts/showall").json(); 
    return Create.data.blogposts ;
    
  };
  
  export default  Create ;